var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMcmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5597_4240)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 12,
    fill: "#AD826E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.008 54L11.018 32.716H10.882C10.9273 33.1693 10.9613 33.7473 10.984 34.45C11.0293 35.1527 11.0633 35.9233 11.086 36.762C11.1087 37.578 11.12 38.4167 11.12 39.278V54H8.298V29.724H12.82L20.3 49.614H20.436L28.052 29.724H32.54V54H29.514V39.074C29.514 38.2807 29.5253 37.4987 29.548 36.728C29.5707 35.9347 29.6047 35.198 29.65 34.518C29.6953 33.8153 29.7293 33.226 29.752 32.75H29.616L21.524 54H19.008ZM46.9297 36.796C45.5697 36.796 44.4137 37.102 43.4617 37.714C42.5097 38.326 41.7844 39.1987 41.2857 40.332C40.787 41.4427 40.5377 42.7573 40.5377 44.276C40.5377 46.6107 41.059 48.4467 42.1017 49.784C43.167 51.0987 44.765 51.756 46.8957 51.756C47.7344 51.756 48.539 51.6767 49.3097 51.518C50.103 51.3367 50.8737 51.0987 51.6217 50.804V53.422C50.8964 53.7167 50.103 53.932 49.2417 54.068C48.3804 54.204 47.451 54.272 46.4537 54.272C44.4364 54.272 42.759 53.8527 41.4217 53.014C40.0844 52.1753 39.0757 51.008 38.3957 49.512C37.7384 47.9933 37.4097 46.2367 37.4097 44.242C37.4097 42.2927 37.7837 40.57 38.5317 39.074C39.3024 37.578 40.3904 36.4107 41.7957 35.572C43.2237 34.7107 44.9124 34.28 46.8617 34.28C47.8364 34.28 48.7884 34.382 49.7177 34.586C50.6697 34.79 51.565 35.096 52.4037 35.504L51.4177 37.918C50.715 37.578 49.9897 37.306 49.2417 37.102C48.4937 36.898 47.723 36.796 46.9297 36.796ZM75.7845 34.552V54H72.9965V41.794C72.9965 41.3407 72.9965 40.842 72.9965 40.298C73.0192 39.7313 73.0419 39.21 73.0645 38.734C73.0872 38.258 73.1099 37.9067 73.1325 37.68H73.0305L67.0465 54H64.4625L58.4785 37.646H58.3765C58.3765 37.8727 58.3879 38.2353 58.4105 38.734C58.4332 39.21 58.4559 39.7313 58.4785 40.298C58.5012 40.8647 58.5125 41.4087 58.5125 41.93V54H55.8265V34.552H59.9405L65.7885 50.328H65.8565L71.6705 34.552H75.7845Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5597_4240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcmLogo);
export default __webpack_public_path__ + "static/media/MCM_Logo.969f44b17b5c82c4e673022c338a85e7.svg";
export { ForwardRef as ReactComponent };